import styled from 'styled-components';

export default styled.span `
  font-family: "Source Sans Pro";
  font-weight: bold;
`;
